import { Button, type ButtonVariant } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

const closeButtonVariant: ButtonVariant = 'secondaryNeutral';
const buttonVariant: ButtonVariant = 'primaryBrand';

export const KycRemediationButton = ({
  handleCloseClick,
  handleUpdateClick,
  showUpdateButton,
}: {
  handleCloseClick: () => void;
  handleUpdateClick: () => void;
  showUpdateButton: boolean;
}) => {
  const { t } = useTranslation('global');

  return showUpdateButton ? (
    <Button
      variant={buttonVariant}
      text={t('invoices.transfer.kycRemediationBanner.actionText')}
      onClick={handleUpdateClick}
    />
  ) : (
    <Button
      variant={closeButtonVariant}
      text={t('misc.close')}
      onClick={handleCloseClick}
      iconName="cross"
    />
  );
};
